import { faChevronRight as ChevronRight } from "@jewlr/pro-regular-svg-icons/faChevronRight"
import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link, useLocation, useParams } from "react-router-dom"
import styled from "styled-components"

import FontAwesomeIcon from "components/font-awesome-icon"
import withArticle from "hoc/helpdesk/with-article"

const Chevron = styled(FontAwesomeIcon).attrs((props) => ({
  icon: props.icon,
}))`
  ${({ theme }) => `
    font-size: ${theme.fontSizes[12]};
    margin-right: ${theme.space[1]};
    margin-bottom: -1px;
  `}
`
const BreadcrumbsContainer = styled(Box).attrs((props) => ({
  color: "#757575",
  fontSize: 14,
  mb: 4,
  ml: { _: 4, tablet: 1 },
  ...props.theme.helpdesk.breadcrumbsContainer,
}))``

const StyledBreadcrumb = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: inline;
  }

  ${(props) => props.theme.helpdesk.breadcrumbSpan}
`

const Breadcrumbs = ({ article, children, helpdeskArticle, results }) => {
  const location = useLocation()
  const { article_id, category_id, collection_id } = useParams()

  let categoryId = category_id
  let collectionId =
    collection_id ||
    helpdeskArticle?.collectionId ||
    article?.article?.collectionId
  let contactPage = location.pathname === "/helpdesk/contact"

  let initialCrumbs = [
    {
      link: "/helpdesk",
      name: "Home",
    },
  ]

  if (collectionId && results) {
    const collection = results[collectionId]
    if (collection) {
      initialCrumbs.push({
        link: `/helpdesk/${collectionId}`,
        name: collection.name,
      })
    }
  }
  if (contactPage) {
    initialCrumbs.push({
      link: "/helpdesk/5e9f51622c7d3a7e9aeb5bfc",
      name: "General Questions",
    })
    initialCrumbs.push({
      link: "/helpdesk/contact",
      name: "Self Help Portal",
    })
  }

  if (categoryId && results[collectionId] && results[collectionId].categories) {
    const category = results[collectionId].categories[categoryId]
    initialCrumbs.push({
      link: `/helpdesk/${collectionId}/${categoryId}`,
      name: category.name,
    })
  }

  if (article_id && article && article.article) {
    let category
    if (article.article.categories.length === 1 && results[collectionId]) {
      categoryId = article.article.categories[0]
      category = results[collectionId].categories[categoryId]
    } else if (article.article.categories.length > 1 && results[collectionId]) {
      category =
        location.state && location.state.category
          ? location.state.category
          : article.article.categories &&
            article.article.categories[0] &&
            results[collectionId].categories[article.article.categories[0]]
      categoryId =
        location.state && location.state.category
          ? location.state.category.id
          : article.article.categories[0]
    }

    if (category) {
      initialCrumbs.push({
        link: `/helpdesk/${collectionId}/${categoryId}`,
        name: category.name,
      })
    }
  } else if (helpdeskArticle && !helpdeskArticle.not_found) {
    let category
    if (helpdeskArticle.categories.length === 1) {
      categoryId = helpdeskArticle.categories[0]
      category = results[helpdeskArticle.collectionId].categories[categoryId]
    } else if (helpdeskArticle.categories.length > 1) {
      category =
        location.state && location.state.category
          ? location.state.category
          : helpdeskArticle.categories &&
            helpdeskArticle.categories[0] &&
            results[collectionId].categories[helpdeskArticle.categories[0]]
    }

    if (category) {
      initialCrumbs.push({
        link: `/helpdesk/${collectionId}/${categoryId}`,
        name: category.name,
      })
    }
  }

  if (location.pathname === "/helpdesk/search") {
    initialCrumbs.push({
      link: "/helpdesk",
      name: "Search",
    })
  }

  return (
    <>
      <BreadcrumbsContainer>
        <nav aria-label="Breadcrumb">
          <StyledBreadcrumb>
            {initialCrumbs.map(({ link, name }, index) => (
              <li key={`${name}`}>
                <Typography
                  as={Link}
                  data-lc="breadcrumbs"
                  mr={link === "/" ? "12px" : "6px"}
                  to={link}
                >
                  {name}
                </Typography>
                <span aria-hidden>
                  {index !== initialCrumbs.length - 1 && (
                    <Chevron icon={ChevronRight} />
                  )}
                </span>
              </li>
            ))}
          </StyledBreadcrumb>
        </nav>
      </BreadcrumbsContainer>
      <div>{children}</div>
    </>
  )
}
Breadcrumbs.propTypes = {
  article: PropTypes.object,
  children: PropTypes.element,
  helpdeskArticle: PropTypes.object,
  results: PropTypes.object,
}

export default withArticle(Breadcrumbs)
